export const MEAL_SLOTS = ['breakfast', 'lunch', 'dinner', 'snacks'] as const;
export type MealSlot = (typeof MEAL_SLOTS)[number];

export const MEAL_SLOT_LABEL: Record<MealSlot, string> = {
  breakfast: 'Breakfast',
  lunch: 'Lunch',
  dinner: 'Dinner',
  snacks: 'Snacks',
};

const SLOT_HOUR: Record<MealSlot, number> = {
  breakfast: 8,
  lunch: 12,
  dinner: 18,
  snacks: 21,
};

export function isMealSlot(v: unknown): v is MealSlot {
  return v === 'breakfast' || v === 'lunch' || v === 'dinner' || v === 'snacks';
}

export function slotFromHour(hour: number): MealSlot {
  if (hour < 11) return 'breakfast';
  if (hour < 15) return 'lunch';
  if (hour < 20) return 'dinner';
  return 'snacks';
}

export function hourForSlot(slot: MealSlot): number {
  return SLOT_HOUR[slot];
}

export function localTimeForSlot(dateKey: string, slot: MealSlot): string {
  const h = String(hourForSlot(slot)).padStart(2, '0');
  return `${dateKey}T${h}:00`;
}
